<app-products-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-products-filters>

<mat-card class="add-button-container" *ngIf="!(products | async).length">
  <h4>Nessun prodotto trovato</h4>
  <button class="add-button" *ngIf="canAdd" mat-raised-button (click)="addProduct()" color="primary">
    Aggiungi
  </button>
</mat-card>

<div class="table-container" [hidden]="!(products | async).length">
  <table mat-table matSort [dataSource]="products" multiTemplateDataRows matSortDisableClear matSortActive="name"
    matSortDirection="asc">

    <ng-container matColumnDef="photo">
      <th mat-header-cell *matHeaderCellDef> Immagine </th>
      <td mat-cell *matCellDef="let element">
        <img [src]="element.photoUrl" alt="Immagine del prodotto" *ngIf="element.photoUrl" class="product-image">
        <img src="../../../../assets/images/no-image.jpg" alt="Immagine del prodotto" *ngIf="!element.photoUrl"
          class="product-image">
      </td>
    </ng-container>


    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let element"> {{ element.name }} <span class="badge-product badge--info" *ngIf="element.editable"
          matTooltip="Prodotto soggetto a variazioni">Variazioni</span></td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Tipo </th>
      <td mat-cell *matCellDef="let element"> {{ element.type }} </td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef> Prezzo </th>
      <td mat-cell *matCellDef="let element"> {{ element.price }} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="add-icon-container">
        <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo prodotto" (click)="$event.stopPropagation(); addProduct()"
          color="primary">
          <mat-icon>add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row" class="modify-icon-container">
        <ng-container>
          <button mat-icon-button (click)="$event.stopPropagation(); editProduct(row)">
            <mat-icon matTooltip="Modifica">create</mat-icon>
          </button>
        </ng-container>

        <button mat-icon-button (click)="$event.stopPropagation(); deleteProduct(row)">
          <mat-icon matTooltip="Elimina">delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editProduct(row)"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSizeOptions[0]" [length]="total">
  </mat-paginator>
</div>
